import React from 'react';
import { Linking, Pressable } from 'react-native';
import PropTypes from 'prop-types';
import { format, parseISO } from 'date-fns';
import { ThePost } from './ThePost';
import { ThePostPlusImage } from './ThePostPlusImage';
import { SupportedSocialPlatforms } from '../SocialLink';

const getSocialIconType = type => {
    if (type.equals(SupportedSocialPlatforms.FACEBOOK)) {
        return 'square-facebook';
    } else if (type.equals(SupportedSocialPlatforms.YOUTUBE)) {
        return 'youtube';
    } else if (type.equals(SupportedSocialPlatforms.INSTAGRAM)) {
        return 'instagram-square';
    } else if (type.indexOf('twitter') !== -1) {
        return 'x-twitter';
    }
};

export const SocialPost = ({ caption, date, icon, id, instagramImage, link, name, socialHandle, type, ...rest }) => {
    if (!type) {
        return null;
    }

    const post = {
        caption,
        date,
        instagramImage,
        icon,
        id,
        name,
        socialHandle,
        socialPostLinkURL: link.externalUrl,
        type,
        ...rest
    };

    const formattedDate = format(typeof post.date === 'string' ? parseISO(post.date) : new Date(post.date), 'MMMM do');

    return (
        <Pressable onPress={() => Linking.openURL(post.socialPostLinkURL)}>
            {type.equals(SupportedSocialPlatforms.INSTAGRAM) && (
                <ThePostPlusImage {...rest} icon={getSocialIconType(type)} postTimeStamp={formattedDate} {...post} />
            )}
            {!type.equals(SupportedSocialPlatforms.INSTAGRAM) && (
                <ThePost {...rest} icon={getSocialIconType(type)} postTimeStamp={formattedDate} {...post} />
            )}
        </Pressable>
    );
};

SocialPost.propTypes = {
    caption: PropTypes.string,
    date: PropTypes.string,
    name: PropTypes.string,
    icon: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    instagramImage: PropTypes.object,
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
        internalKey: PropTypes.string
    }),
    socialHandle: PropTypes.string
};
